import React from "react";
import styled from "styled-components";
import { device } from "../styled";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Bubble = styled.p`
  width: 75%;
  position: relative;
  background-color: #000;
  color: #fff;
  padding: 1.125em 1.125em;
  font-size: 1.1em;
  border: 3px #fff solid;
  border-radius: 1rem;
  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.3),
    0 0.0625rem 0.125rem rgba(0, 0, 0, 0.2);

  &::before {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    bottom: 100%;
    left: 1.5em;
    border: 0.75rem solid transparent;
    border-top: none;
    border-bottom-color: #fff;
    filter: drop-shadow(0 -0.0625rem 0.0625rem rgba(0, 0, 0, 0.1));
  }

  @media ${device.tablet} {
    width: 40%;
  }
`;

const Name = styled.p`
  margin: 20px 0 0 0;
  text-align: right;
  font-weight: 100;
  font-style: italic;
  font-size: 0.9em;
`;

const PeaceIcon = styled.img`
  width: 40px !important;
`;

const NameContainer = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: end;
  align-items: center;
`;

const ThinkBubble = ({ text, name }) => {
  return (
    <Container>
      <Bubble>
        {text}
        <NameContainer>
          <Name>{name}</Name>
          <PeaceIcon src="/peace.png" alt="peace" />
        </NameContainer>
      </Bubble>
    </Container>
  );
};

export default ThinkBubble;
